//export const URL: string = "http://localhost/citizenScience/";
export const URL: string = "https://citizenscience.lifewatchitaly.eu/webapp-admin/";

export const esriApiKey = "AAPK830b060bbb7e411cac23c1e23622b346cG4Zyaux_sy-Y0lsE8vfMpwsNynBqG7UoL6zqhwqvj-kEFB4I3B_Y6EN7YPWT7zB";
export const esriBasemapEnum = "arcgis/imagery/standard";

/*
"C:\Program Files (x86)\Google\Chrome\Application\chrome.exe" --disable-web-security --disable-gpu --user-data-dir=~/chromeTemp
*/